import RolePermissions from "./RolePermissions";

interface UpdateRoleProps {
    roleData: any;
    setShowPermissionsSection: (value: boolean) => void;
    setFlag: (value: boolean) => void;
}
const UpdateRole = ({
    roleData,
    setShowPermissionsSection,
    setFlag
}:UpdateRoleProps) => {

    return (
        <>
            <RolePermissions 
                roleData={roleData}
                setShowPermissionsSection={setShowPermissionsSection}
                action={'update-role'}
                setFlag={setFlag}
            />
        </>
    );
}

export default UpdateRole;